import {
  useCpmsBoLoginMutation,
  useCpmsBoRequestLoginOtpMutation,
} from '@app/core/service/auth.service';

import { EmailPasswordStepView } from './email-password-step.view';
import { EmailPasswordForm } from './use-email-password.form-validation';

interface EmailPasswordStepControllerProps {
  readonly onNext: (payload: {
    emailAddress: string;
    token: string;
    password: string;
  }) => void;
  readonly onRememberMeChange: (value: boolean) => void;
  readonly onSendOtpError: () => void;
  readonly handleForgottenPassword: () => void;
}

export function EmailPasswordStepController({
  onNext,
  onRememberMeChange,
  onSendOtpError,
  handleForgottenPassword,
}: EmailPasswordStepControllerProps): React.JSX.Element {
  const [login, { error: loginError, isLoading: isLoginLoading }] =
    useCpmsBoLoginMutation();
  const [sendOtp, { error: otpError, isLoading: isOtpLoading }] =
    useCpmsBoRequestLoginOtpMutation();

  async function handleLogin(payload: EmailPasswordForm): Promise<void> {
    const resultLogin = await login({
      emailAddress: payload.emailAddress,
      password: payload.password,
    });
    if (resultLogin.error || !resultLogin.data) {
      return;
    }

    const resultSendOtp = await sendOtp({
      emailAddress: payload.emailAddress,
      token: resultLogin.data.accessToken,
    });

    if (!resultSendOtp.data) {
      onSendOtpError();
      return;
    }

    onNext({
      emailAddress: payload.emailAddress,
      password: payload.password,
      token: resultLogin.data.accessToken,
    });
  }

  return (
    <EmailPasswordStepView
      onRememberMeChange={onRememberMeChange}
      pending={isLoginLoading || isOtpLoading}
      isError={!!loginError || !!otpError}
      onSubmit={handleLogin}
      handleForgottenPassword={handleForgottenPassword}
    />
  );
}
